const firebaseConfig = {
    apiKey: "AIzaSyCqICUyC8D_7cTt50tzhe3Ek65UZo3xMsU",
    authDomain: "rainbow-automobiles.firebaseapp.com",
    projectId: "rainbow-automobiles",
    storageBucket: "rainbow-automobiles.appspot.com",
    messagingSenderId: "1067073372909",
    appId: "1:1067073372909:web:d2011eaf3f09b1cf02c2e4"
};

export default firebaseConfig;